import {TEXT} from '@drivesally/sally-fw/lib/inputTypes';

// Attribute
import attribute from '@drivesally/sally-fw/lib/attribute/attribute';

export default attribute({
  type: TEXT,
  attribute: 'owner_name',
  label: {
    default: 'Owner Name',
    short: 'Owner Name',
  },
});
